import { useEffect, useState } from 'react';
// create a new card
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { default: CreditCardGenerator } = require('@mihnea.dev/credit-card-generator');
function useFakeCreditCard() {
    const [cardData, setCardData] = useState({
        number: '----------------',
        expiry: {
            month: 0,
            year: 0
        },
        cvv2: '---'
    });
    const initCard = () => {
        // validate the objet in localstorage by key
        const card = localStorage.getItem('fake-card');
        if (card) {
            const localCardData = JSON.parse(card);
            setCardData(localCardData);
        }
        else {
            /** Initialize new Credit Card Generator */
            const carder = new CreditCardGenerator();
            /** Create a single card */
            const card = carder.generate_one();
            localStorage.setItem('fake-card', JSON.stringify(card));
            setCardData(card);
        }
    };
    useEffect(() => {
        initCard();
    }, []);
    return { cardNumber: cardData === null || cardData === void 0 ? void 0 : cardData.number, expiry: cardData === null || cardData === void 0 ? void 0 : cardData.expiry, cvv2: cardData === null || cardData === void 0 ? void 0 : cardData.cvv2 };
}
export default useFakeCreditCard;
